import { useEffect, useState } from "react"
import appConfig from "../config";
import axios from "axios";


export const useMaintenanceHook = () => {
    const [isMaintenance, setIsMaintenance] = useState<boolean>(false);
    const [startDate, setStartDate] = useState<string|null>(null);
    const [endDate, setEndDate] = useState<string|null>(null);
    const minutes = 1000 * 60 * 10;

    useEffect(() => {
        // getSiteCheck();
        // setInterval(() => {
        //     getSiteCheck();
        // },minutes);
    }, [minutes]);

    const getSiteCheck = async() => {
        axios({
            method: "get",
            url: `${appConfig.baseApiUrl}/api/site-check`,
            headers: {
                Accept: "application/json",
            }
        }).then((response) => {
            const maintenanceModeOn = response.data.data.is_maintenance;
            console.log('maintenanceModeOn', maintenanceModeOn);
            setIsMaintenance(maintenanceModeOn);
            if (maintenanceModeOn) {
                setStartDate(response.data.data.start_date);
                setEndDate(response.data.data.end_date);
            }
        }).catch((error) => {
            setIsMaintenance(false);
            setStartDate(null);
            setStartDate(null);

        });
    }

    return { isMaintenance, startDate, endDate };

}
